import { uuidv4 } from '@firebase/util';
import { Tree } from '../pages/mindmap/types';
import { treeRootToFlatNode } from './treeRootToFlatNode';

/**
 * Regenerates a node by returning a copy with a new ID.
 * @param node Node to regenerate
 * @param keepId False to generate new ID, true to keep existing ID.
 * @param idMap An map between old ids as keys and new ids as values.
 *              A new record with the existing id as key the generated id as value will be created.
 *              Can be used to keep hierarchy when regenerating multiple nodes by supplying the same idMap
 *              Can be used to set the PID of the 'root' node manually.
 * @returns
 */
export const regenerateNode = (node: Tree, keepId: boolean, idMap: Record<string, string>) => {
  let newId = keepId ? node.id : uuidv4();
  idMap[node.id] = newId;
  const nodeCopy = { ...node, id: newId, pid: node.pid ? idMap[node.pid] : null };
  const flatNode = treeRootToFlatNode(nodeCopy);
  return flatNode;
};
